export const shortcuts = {
  search: '/',
  gridView: '[',
  listView: ']',
} as const
